import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TotalCropReportTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid, Card, Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { pluckerPerformanceReportSchema } from "../pluckerPerformanceReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = 'ANNUALLABOURATTENDANCEMONITORINGREPORT'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function PluckerPerformanceReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [gang, setGang] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        year: ""
    });
    const [totalRow, setTotalRow] = useState({
        pluckingCount: 0,
        sundry: 0,
        nameTotal: 0,
        overKilo: 0,
        total: 0,
        pluAvg: 0,
        overKiloPec: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(pluckerPerformanceReportSchema).options({ allowUnknown: true });
    const months = [
        { month: 1, monthName: "January" }, { month: 2, monthName: "February" },
        { month: 3, monthName: "March" }, { month: 4, monthName: "April" },
        { month: 5, monthName: "May" }, { month: 6, monthName: "June" },
        { month: 7, monthName: "July" }, { month: 8, monthName: "August" },
        { month: 9, monthName: "September" }, { month: 10, monthName: "October" },
        { month: 11, monthName: "November" }, { month: 12, monthName: "December" }
    ];
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [pluckingDays, setPluckingDays] = useState([]);
    const [sundryDaysModel, setSundryDays] = useState([]);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });
    const [firstDay, setfirstDay] = useState(new Date());
    const [lastDay, setlastDay] = useState(new Date());

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedDate2, setSelectedDate2] = useState(new Date());
    const handleDateChange = (date) => {
        setSelectedDate(date);
        var date1 = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);
        setfirstDay(firstDay)
        setlastDay(lastDay)
    };
    const handleDateChange2 = (date) => {
        setSelectedDate2(date);
    };
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWANNUALLABOURATTENDANCEMONITORINGREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, pluckerPerformanceReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }

    async function handleSearch(e) {

        const reportData = await service.GetReportDetails(searchData.collectionPointID, selectedDate, selectedDate2);
        setSelectedSearchData();
        let firstDataModel = reportData.firstDataModel
        let secondDataModel = reportData.secondDataModel
        let pluckingDaysModel = reportData.pluckingDaysModel
        let sundryDaysModel = reportData.sundryDaysModel

        const uniqueArr1 = pluckingDaysModel.filter((obj, index, self) => {
            return index === self.findIndex((t) => {
                return t.cardReadTime === obj.cardReadTime;
            });
        });

        const uniqueArr2 = sundryDaysModel.filter((obj, index, self) => {
            return index === self.findIndex((t) => {
                return t.cardReadTime === obj.cardReadTime;
            });
        });
        const merged = _.merge(_.keyBy(firstDataModel, 'employeeID'), _.keyBy(secondDataModel, 'employeeID'));

        const mergedArray = _.values(merged);
        setPluckingDays(uniqueArr1);
        setSundryDays(uniqueArr2);

        mergedArray.forEach(x => {
            let total = 0;
            let overKilo = 0;
            let nameTotal = 0;
            let overKiloPec = 0;
            let calOverKilo = 0;
            let plucking = 0;
            let sundry = 0;
            let sundryPec = 0;
            let pluckingCount = 0;
            let pluckingPec = 0;
            let plcAvg = 0;
            if (x.dataModel != undefined) {
                x.dataModel.forEach(y => {
                    total = total + y.totalAmount;
                    calOverKilo = (y.totalAmount - y.configurationValue)
                    overKilo = (calOverKilo > 0) ? overKilo + calOverKilo : overKilo + 0
                    overKiloPec = (overKilo / total) * 100
                    nameTotal = total - overKilo
                    plucking = (y.configurationValue <= y.totalAmount) ? 1 : 0.5;
                    pluckingCount = pluckingCount + plucking;
                    pluckingPec = (pluckingCount / uniqueArr1.length) * 100
                    plcAvg = total / pluckingCount
                })
            }

            if (x.dataModelTwo != undefined) {
                x.dataModelTwo.forEach(z => {
                    sundry = sundry + 1
                    sundryPec = (sundry / uniqueArr2.length) * 100
                })
            }
            x.total = total;
            x.overKilo = overKilo;
            x.nameTotal = nameTotal;
            x.overKiloPec = overKiloPec
            x.sundry = sundry
            x.sundryPec = sundryPec
            x.pluckingCount = pluckingCount
            x.pluckingPec = pluckingPec
            x.plcAvg = plcAvg

        });
        let newRes = _.cloneDeep(mergedArray);
        let pluckingCount = 0;
        let sundry = 0;
        let nameTotal = 0;
        let overKilo = 0;
        let total = 0;
        let pluAvg = 0;
        let overKiloPec = 0;
        newRes.forEach(x => {
            pluckingCount = pluckingCount + x.pluckingCount
            sundry = sundry + x.sundry
            nameTotal = nameTotal + x.nameTotal
            overKilo = overKilo + x.overKilo
            total = total + x.total;
            pluAvg = total / pluckingCount
            overKiloPec = (overKilo / total) * 100
        })
        setTotalRow({
            ...totalRow,
            pluckingCount: pluckingCount,
            sundry: sundry,
            nameTotal: nameTotal,
            overKilo: overKilo,
            total: total,
            pluAvg: pluAvg,
            overKiloPec: overKiloPec
        });
        const strAscending = [...mergedArray].sort((a, b) =>
            a.epfNo > b.epfNo ? 1 : -1,
        );
        setReportData(strAscending);
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            gangID: gang[searchData.gangID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Plucker Performance Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Division *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-4 pb-1">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            id="date-picker-inline"
                                            label="From *"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-4 pb-1">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            minDate={selectedDate}
                                            maxDate={lastDay}
                                            id="date-picker-inline"
                                            label="To *"
                                            value={selectedDate2}
                                            onChange={handleDateChange2}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <>
                                    <div className="row pl-2 pb-4 pt-4">
                                        <Grid container>
                                            <Grid style={{ marginLeft: '15px', marginRight: '10px' }}>
                                                <b>
                                                    Plucking Days Offered : {pluckingDays.length}
                                                </b>
                                            </Grid>
                                        </Grid>
                                        <Grid style={{ marginTop: '10px' }} container>
                                            <Grid style={{ marginLeft: '15px', marginRight: '10px' }}>
                                                <b>
                                                    Sundry Days Offered : {sundryDaysModel.length}
                                                </b>
                                            </Grid>
                                        </Grid>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-12 pb-1">
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer >
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>EPF</TableCell>
                                                                    <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Name</TableCell>
                                                                    <TableCell align="center" colSpan={4} style={{ fontWeight: "bold", border: "2px solid black" }}>Days Worked (NAMES)</TableCell>
                                                                    <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Name kg</TableCell>
                                                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Over kg</TableCell>
                                                                    <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Total kg</TableCell>
                                                                    <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>PLK AVG</TableCell>
                                                                </TableRow>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Plucking</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}> %</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Sundry</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>%</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>kgs</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>%</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                    <TableRow style={{ border: "2px solid black" }} key={i}>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.epfNo}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="left"> {row.firstName}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.pluckingCount == 0 ? '-' : row.pluckingCount}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.pluckingPec == 0 ? '-' : parseInt(row.pluckingPec)}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.sundry == 0 ? '-' : row.sundry}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.sundry == 0 ? '-' : parseInt(row.sundryPec)}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.nameTotal == 0 ? '-' : row.nameTotal}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.overKilo == 0 ? '-' : row.overKilo}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.overKilo == 0 ? '-' : parseInt(row.overKiloPec)}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.total == 0 ? '-' : row.total}</TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.plcAvg == 0 ? '-' : parseInt(row.plcAvg)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                                )}
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell component="th" scope="row" align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}> Total</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{totalRow.pluckingCount}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{parseFloat((totalRow.pluckingCount / (totalRow.pluckingCount + totalRow.sundry)) * 100).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{totalRow.sundry}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{parseFloat((totalRow.sundry / (totalRow.pluckingCount + totalRow.sundry)) * 100).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{totalRow.nameTotal}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{totalRow.overKilo}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{parseFloat(totalRow.overKiloPec).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{totalRow.total}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>{parseFloat(totalRow.pluAvg).toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        component="div"
                                                        count={reportData.length}
                                                        onChangePage={handlePageChange}
                                                        onChangeRowsPerPage={handleLimitChange}
                                                        page={page}
                                                        rowsPerPage={limit}
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                    />
                                                </Paper>
                                            </Card>
                                        </div>
                                    </div> </> : null}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Plucker Performance Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} reportData={reportData} months={months}
                                            searchData={selectedSearchValues} totalRow={totalRow} selectedDate={selectedDate} selectedDate2={selectedDate2}
                                            pluckingDays={pluckingDays} sundryDaysModel={sundryDaysModel} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



